import { useEffect, useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import CentralConfig from "./CentralConfig";
import DeltaGammaOffset from "./Adjustment/DeltaGammaOffset";
import DeltaGammaInput from "./Adjustment/DeltaGammaInput";
import DeltaInput from "./Adjustment/DeltaInput";
import EmergencyOffset from "./Adjustment/EmergencyOffset";
import DeltaOffset from "./Adjustment/DeltaOffset";
import { IDeltaHedgeExeCommonConfigDTO } from "../../../Interfaces/deltaHedgeExe";
import { getDeltaHedgeExeCentralConfig } from "../../../Requests/deltaHedgeExe";
import { packetErrorHandler } from "../../../Utils/requestUtils";
// Components
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
// Local Components
import GroupConfig from "./GroupConfig";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
// Requests
import { getGroups } from "src/Requests/optionDomain";

enum ModalMode {
  Closed,
  CentralConfig,
  DeltaGammaOffset,
  DeltaGammaInput,
  DeltaInput,
  EmergencyOffset,
  DeltaOffset,
  Group,
}

const ExeConfig = () => {
  const [groups, setGroups] = useState([] as DropdownItem[]);
  const [groupId, setGroupId] = useState<string | number>("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [centralConfig, setCentralConfig] = useState(
    {} as IDeltaHedgeExeCommonConfigDTO
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getDeltaHedgeExeCentralConfig()
      .then((resp) => {
        setCentralConfig(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));

    getGroups()
      .then((resp) => {
        setGroups(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.CentralConfig:
        return (
          <CentralConfig
            onClose={() => setModalMode(ModalMode.Closed)}
            formValues={centralConfig}
            setFormValues={setCentralConfig}
          />
        );

      case ModalMode.DeltaGammaOffset:
        return (
          <DeltaGammaOffset
            isModalOpen={modalMode === ModalMode.DeltaGammaOffset}
            onClose={() => setModalMode(ModalMode.Closed)}
            centralConfig={centralConfig}
          />
        );

      case ModalMode.DeltaGammaInput:
        return (
          <DeltaGammaInput
            isModalOpen={modalMode === ModalMode.DeltaGammaInput}
            onClose={() => setModalMode(ModalMode.Closed)}
            centralConfig={centralConfig}
          />
        );

      case ModalMode.DeltaInput:
        return (
          <DeltaInput
            isModalOpen={modalMode === ModalMode.DeltaInput}
            onClose={() => setModalMode(ModalMode.Closed)}
            centralConfig={centralConfig}
          />
        );

      case ModalMode.EmergencyOffset:
        return (
          <EmergencyOffset
            isModalOpen={modalMode === ModalMode.EmergencyOffset}
            onClose={() => setModalMode(ModalMode.Closed)}
            centralConfig={centralConfig}
          />
        );

      case ModalMode.DeltaOffset:
        return (
          <DeltaOffset
            isModalOpen={modalMode === ModalMode.DeltaOffset}
            onClose={() => setModalMode(ModalMode.Closed)}
            centralConfig={centralConfig}
          />
        );

      case ModalMode.Group:
        return (
          <GroupConfig
            onClose={() => setModalMode(ModalMode.Closed)}
            header={modalTitle}
            groupId={groupId}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      {modalMode !== ModalMode.Closed ? (
        <Modal title={modalMode === ModalMode.CentralConfig ? "تنظیمات مرکزی" : modalMode === ModalMode.DeltaGammaOffset ? "آفستی دلتا و گاما" : modalMode === ModalMode.DeltaGammaInput ? "ورودی دلتا و گاما" : modalMode === ModalMode.DeltaInput ? "ورودی دلتا" : modalMode === ModalMode.EmergencyOffset ? "آفستی اضطراری" : modalMode === ModalMode.DeltaOffset ? "آفستی دلتا" : "گروه"}
          UI={getModalUI()}
          onClose={() => setModalMode(ModalMode.Closed)}
        />
      ) : (
        <></>
      )}
      {loading ? <FullScreenLoading /> : <></>}
      <div className="flex flex-row justify-start items-center gap-3">
        <div>مرکزی:</div>
        <Button
          text="تنظیمات مرکزی"
          variant="contained"
          onClick={() => {
            setModalMode(ModalMode.CentralConfig);
            setModalTitle("");
          }}
        />
      </div>
      <div className="flex flex-row justify-start items-center gap-3">
        <div>تعدیل:</div>
        <Button
          text="آفستی دلتا و گاما"
          variant="contained"
          onClick={() => setModalMode(ModalMode.DeltaGammaOffset)}
        />
        <Button
          text="آفستی دلتا"
          variant="contained"
          onClick={() => setModalMode(ModalMode.DeltaOffset)}
        />
        <Button
          text="ورودی دلتا و گاما"
          variant="contained"
          onClick={() => setModalMode(ModalMode.DeltaGammaInput)}
        />
        <Button
          text="ورودی دلتا"
          variant="contained"
          onClick={() => setModalMode(ModalMode.DeltaInput)}
        />
        <Button
          text="آفستی اضطراری"
          variant="contained"
          onClick={() => setModalMode(ModalMode.EmergencyOffset)}
        />
      </div>
      <div className="flex flex-row justify-start items-center gap-3">
        <div>گروه:</div>
        {groups.map((group) => (
          <Button
            key={group.id}
            text={group.name}
            variant="contained"
            onClick={() => {
              setModalMode(ModalMode.Group);
              setModalTitle(group.name);
              setGroupId(group.id);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ExeConfig;
